import React, { useState, useEffect } from 'react';
import axios from 'axios';
import routes from '../api_routes';
import './SubmissionApprovalSection.css';

const SubmissionApprovalSection = ({initialData, toastContainer, startExpanded}) =>
{
    const [submissionData, setSubmissionData] = useState(initialData);
    const [metadata, setMetadata] = useState(null);
    const [approvalState, setApprovalState] = useState(null);

    useEffect(() => {
        const getEpisodeMetadata = async () => {
            const token = localStorage.getItem('token');
            const endpoint = `${routes.upload}/${submissionData.channel}/${submissionData.reference_id}/metadata`;
            const response = await axios.get(endpoint, {headers:{Authorization: `Bearer ${token}`}});
            setMetadata(response.data);
        }

        getEpisodeMetadata();
    }, []);

    const approveSubmission = async() => {
        const token = localStorage.getItem('token');
        const endpoint = `${routes.submissions}/approve`;
        const response = await axios.post(endpoint, {
            'video_id': submissionData.reference_id,
            'channel_id': submissionData.channel
        }, {headers:{Authorization: `Bearer ${token}`}});
        setApprovalState(response.data['status']);
    }

    return (
        <span>
            {metadata ?
            <span className="SubmissionInfo">
                <h4>{submissionData.name}: {metadata.name}</h4>
                {approvalState ? 
                <h5 className="SubmissionState">{approvalState}</h5>
                : <button onClick={approveSubmission} className="StandardButton">Post now</button>}
            </span>
            :
            <p>Loading...</p>
            }
        </span>
    );
}
export default SubmissionApprovalSection;